"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f227 = void 0;
exports.f227 = {
    "ãvõkáyã": [
        543,
        544
    ],
    "ãrị̃ngã tị": [
        4519
    ],
    "ãrị̃ngã": [
        4519
    ]
};
